"use strict";

var $ = require("jquery");
var common = require("./common");

var PWD_KEYUP_ABLE = true;
var CF_PWD_KEYUP_ABLE = true;


function ResetForgotPassword (params) {
    this.resetPasswordWidgetInstance = params.resetPasswordWidgetInstance;
    this.email = params.email;
    this.environment = params.environment;
    this.apigeeKey = params.apigeeKey;
    this.token = params.token;
    this.passwordPlaceholder = params.passwordPlaceholder;
    this.passwordConfirmationPlaceholder = params.confirmPasswordPlaceholder;
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/passwords/reset-requests';
    this.locale = params.language;
}

ResetForgotPassword.prototype.init = function (requestId) {
    var self = this;
    this.resetForgotPwdParent = this.resetPasswordWidgetInstance.resetForgotPasswordParent.find(".reset-password");
    this.clearErrorMessages();
    var passwordField = this.resetForgotPwdParent.find("input#uim-uPassword-input");
    var confirmPasswordField = this.resetForgotPwdParent.find("input#uim-uPasswordConfirmation-input");

    var submit = this.resetForgotPwdParent.find("input#uim-changePassword-submit");
    var inputErrors = this.resetForgotPwdParent.find("#input-errors");
    var confirmPasswordError = this.resetForgotPwdParent.find("#confirm-password-error");
    this.fields = {
        password: passwordField,
        confirmPassword: confirmPasswordField
    };

    if (this.passwordPlaceholder) {
        passwordField[0].placeholder = this.passwordPlaceholder;
    }
    if (this.passwordConfirmationPlaceholder) {
        confirmPasswordField[0].placeholder = this.passwordConfirmationPlaceholder;
    }

	passwordField.on("focus", function () {
		var isEmptyPWD = self.fields.password.val().length === 0;
		if(isEmptyPWD){
			PWD_KEYUP_ABLE = true;
			$("div#password-input-area").removeClass("error");
			common.hideElement(inputErrors.find(".uim-message.empty-password-input"));
			common.hideElement(inputErrors.find(".uim-message.required"));
			common.hideElement(inputErrors.find(".uim-message.maxlength"));
		}
    });
	
    passwordField.on("blur", function () {
		PWD_KEYUP_ABLE = common.validateRequiredField(passwordField,inputErrors,".uim-message.required");
        if(common.validateRequiredField(passwordField,inputErrors,".uim-message.required")) {
            PWD_KEYUP_ABLE = common.validatePassword(passwordField, inputErrors, self.email);
        } else {
            common.hideElement(inputErrors.find(".uim-message.maxlength"));
        }
        self.updateSubmitState();
    });

    passwordField.on("keyup", function () {
		if(!PWD_KEYUP_ABLE){
			if(common.validateRequiredField(passwordField,inputErrors,".uim-message.required")) {
				PWD_KEYUP_ABLE = common.validatePassword(passwordField, inputErrors, self.email);
			} else {
				common.hideElement(inputErrors.find(".uim-message.maxlength"));
			}
			self.updateSubmitState();

			}
    });

	confirmPasswordField.on("focus", function () {
		var isEmptyCFPWD = self.fields.confirmPassword.val().length === 0;
		if(isEmptyCFPWD){
			CF_PWD_KEYUP_ABLE = true;
			$("div#change-confirm-password-input-area").removeClass("error");
			common.hideElement(confirmPasswordError.find(".uim-message.password-empty-input"));
			common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
		}
    });

    confirmPasswordField.on("blur", function () {
		CF_PWD_KEYUP_ABLE = common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password_match")
        if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password_match")) {
            CF_PWD_KEYUP_ABLE = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
        }
        self.updateSubmitState();
    });

    confirmPasswordField.on("keyup", function () {
        if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password_match")) {
            CF_PWD_KEYUP_ABLE = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
        }
        self.updateSubmitState();
    });

    submit.on("click enter", function (e) {
        e.preventDefault();
        self.submit({
            password: self.fields.password.val(),
            locale: self.locale,
            requestId: requestId
        });
    });
};

ResetForgotPassword.prototype.updateSubmitState = function() {
    if(this.allFilled() && !this.checkValidationErrors()) {
        $('#uim-changePassword-submit').removeAttr('disabled');
    } else {
        $('#uim-changePassword-submit').attr("disabled", true);
    }
};

ResetForgotPassword.prototype.showInputErrors = function (status) {
    var submitErrorsElement = this.resetForgotPwdParent.find("#submit-errors");
    if (status === 400) {
        this.resetForgotPwdParent.find("input#uim-uPassword-input").parent().addClass("error");
        this.resetForgotPwdParent.find("input#uim-uPasswordConfirmation-input").parent().addClass("error");
        common.showElement(submitErrorsElement.find(".uim-message.authentication_error"));
    } else if (!!status) {
        common.showElement(submitErrorsElement.find(".uim-message.unknown_server_error"));

    }
};

ResetForgotPassword.prototype.clearErrorMessages = function () {
    var inputErrorsElement = this.resetForgotPwdParent.find("#input-errors");
    var submitErrorsElement = this.resetForgotPwdParent.find("#submit-errors");
    var confirmPasswordElement = this.resetForgotPwdParent.find("#confirm-password-error");
    common.hideElement(submitErrorsElement.find(".uim-message.authentication_error"));
    common.hideElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
    common.hideElement(inputErrorsElement.find(".uim-message.required"));
    common.hideElement(inputErrorsElement.find(".uim-message.maxlength"));
    common.hideElement(confirmPasswordElement.find(".uim-message.password_match"));
};

ResetForgotPassword.prototype.allFilled = function(){
    var filled = true;
    var isEmptyPassword = this.fields.password.val().length === 0;
    var isEmptyConfirmPassword = this.fields.confirmPassword.val().length === 0;

    if(isEmptyPassword || isEmptyConfirmPassword){
        filled = false;
    }

    return filled;
};

ResetForgotPassword.prototype.checkValidationErrors = function() {

    var inputErrorsElement = this.resetForgotPwdParent.find("#input-errors");
    var submitErrorsElement = this.resetForgotPwdParent.find("#submit-errors");
    var confirmPasswordElement = this.resetForgotPwdParent.find("#confirm-password-error");
    return (
    common.checkElement(submitErrorsElement.find(".uim-message.authentication_error")) ||
    common.checkElement(submitErrorsElement.find(".uim-message.unknown_server_error")) ||
    common.checkElement(inputErrorsElement.find(".uim-message.required")) ||
    common.checkElement(inputErrorsElement.find(".uim-message.maxlength")) ||
    common.checkElement(confirmPasswordElement.find(".uim-message.password_match")));
};

ResetForgotPassword.prototype.submit = function (params) {
    var returnURL;
    if (typeof getUrlParameter("returnURL") != 'undefined') {
        returnURL = getUrlParameter("returnURL");
    } else returnURL = "";
    var self = this;

    $.ajax({
        method: "PATCH",
        url: this.apiUrl + "/" + this.token,
        xhrFields: {
            withCredentials: true
        },
        data: JSON.stringify({
            data : {
                type : "password-reset-request" ,
                id : this.token ,
                attributes : {
                    password : params.password,
                    locale: params.locale
                }
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": params.requestId
        }
    }).success(function(data, status) {
        common.showElement(self.resetForgotPwdParent.find("#changed"));
        common.hideElement(self.resetForgotPwdParent.find("#notChanged"));
        if(returnURL !== "") {
            setTimeout(function () {
                window.location.replace(returnURL);
            }, 1500);
        }
    }).error(function (xhr) {
        self.showInputErrors(xhr.status);
    });
};

module.exports = ResetForgotPassword;



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/change-forgotten-password.js
// module id = 20
// module chunks = 0